import React, { Fragment } from "react";
import { View, Text, Divider, Icon, A } from "./components";

export default function Footer(props) {
  return (
    <Fragment>
      <Divider mt={6} thick={props.isWide} />
      <Text
        textStyle="bread"
        my={[2, 4, 5]}
        style={{
          display: "flex",
          ...(!props.isWide && { flexDirection: "column-reverse" }),
        }}
      >
        <View style={{ flex: 1 }} pt={!props.isWide ? 5 : 1}>
          {!props.isWide && <Text my={3}>House of Orange</Text>}
          {props.isWide && <Text inline>HOUSE OF ORANGE — </Text>}Leidsegracht
          6H&ensp;—&ensp;1016 CK Amsterdam, The Netherlands
          <Text inline> — </Text>
          <A textStyle="bread" href="mailto:info@houseoforange.nl">
            info@houseoforange.nl
          </A>
          &ensp;&ensp;
          <A textStyle="bread" href="tel:+31206223303">
            +31 (0)20 622 3303
          </A>
        </View>
        <View pt={!props.isWide ? 5 : 1}>
          <A href="https://www.facebook.com/Houseoforange" target="_blank">
            <Icon icon="facebook" mr={3} />
          </A>
          <A
            href="https://www.instagram.com/houseoforangeagency"
            target="_blank"
          >
            <Icon icon="instagram" />
          </A>
        </View>
      </Text>
    </Fragment>
  );
}
